import payslips from './team-members-payslips.js';
import invitations from './team-members-invitation.js';

export default [...payslips, ...invitations];
